import { getDocument } from 'pdfjs-dist';
import { parseGIF, decompressFrames } from 'gifuct-js'
import { maxFilesPerNetwork, listNetworkSort} from './constante'
import FastAverageColor from 'fast-average-color';


const fac = new FastAverageColor();

//getFilesByNetwork(medias = this.formData.files, networks = this.listNetworkSort, formDataNetwork = this.formData.formDataNetwork, files = this.files, isUploadRequired = false)
export const getFilesByNetwork = (medias, networks, formDataNetwork, files, isUploadRequired = false) => {
    console.log("getFilesByNetwork",{networks,files,medias})
    let filesPerNetwork = {}
    networks.forEach(networkName => {
        filesPerNetwork[networkName] = medias.reduce((filesAccumulator,media) => {
            //echec de de l'upload
            console.log("getFilesByNetwork media", media)

            if (!files[media.id] || (!files[media.id].isUpload && (isUploadRequired || !files[media.id].uploadProgress))) return filesAccumulator
            const file = files[media.id];

            if (file.errorNetwork.hasOwnProperty(networkName)) return filesAccumulator
          
            switch (networkName) {
                case 'facebook':
                    if (formDataNetwork.facebook.typeMedia == 'mixed') break;
                    if (formDataNetwork.facebook.typeMedia == 'video' && file.info.type2 !== 'video') return filesAccumulator
                    if (formDataNetwork.facebook.typeMedia == 'image' && (file.info.type2 !== 'image' || file.info.type == 'image/gif')) return filesAccumulator
                    break;
                case 'instagram':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    break;
                case 'linkedin':
                    if (formDataNetwork.linkedin.survey && formDataNetwork.linkedin.survey.active) return filesAccumulator
                    if (formDataNetwork.linkedin.typeMedia == 'video' && (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video'))) return filesAccumulator
                    if (file.info.type2 !== formDataNetwork.linkedin.typeMedia) return filesAccumulator
                    break;
                case 'threads':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    break;
                case 'twitter':
                    if (formDataNetwork.twitter.typeContent == 'video' && (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video'))) return filesAccumulator
                    if (file.info.type2 !== formDataNetwork.twitter.typeContent) return filesAccumulator
                    break;
                case 'bluesky':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    if (filesAccumulator.length > 0 && filesAccumulator[0].info.type2 !== file.info.type2) return filesAccumulator
                    break;
                case 'tiktok':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    if (file.info.type2 === 'video' && filesAccumulator.some(f => f.info.type2 === 'video')) return filesAccumulator
                    if (file.info.type2 === 'video' && filesAccumulator.some(f => f.info.type2 === 'image')) return filesAccumulator
                    if (file.info.type2 === 'image' && filesAccumulator.some(f => f.info.type2 === 'video')) return filesAccumulator
                    break;
                case 'google':
                    if (file.info.type2 !== 'image' || file.info.type == 'image/gif' || filesAccumulator.some(f => f.info.type2 == 'image')) return filesAccumulator
                    break
                case 'telegram':
                    return filesAccumulator
                case 'pinterest':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif' || filesAccumulator.some(f => ['video', 'image'].includes(f.info.type2))) return filesAccumulator
                    break;
                case 'youtube':
                    if (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video')) return filesAccumulator
                    break;
                
                default:

                    break;
            }

            let imagePreview = null
            if (media.imagePreview && media.imagePreview.id && files[media.imagePreview.id]) {
                const previewFile = files[media.imagePreview.id];
                const url = previewFile.normalizedNetworks[networkName] && previewFile.normalizedNetworks[networkName].url ? previewFile.normalizedNetworks[networkName].url : previewFile.url
                imagePreview = {
                    id: previewFile.id,
                    url: url,
                    type: previewFile.info.type,
                    enclosure: url,
                };
            }


            const info = {...file.info, ...(file.normalizedNetworks && file.normalizedNetworks[networkName] && file.normalizedNetworks[networkName].info ? file.normalizedNetworks[networkName].info : {})}
            let fileData = {
                ...file,
                ...info,
                imagePreview,
                info,
                url : file.normalizedNetworks && file.normalizedNetworks[networkName] && file.normalizedNetworks[networkName].url ? file.normalizedNetworks[networkName].url : file.url,
            };

            return [...filesAccumulator, fileData]

        },[]).slice(0,maxFilesPerNetwork[networkName])
    })
    return filesPerNetwork
}

export const getInfoFile = async (file, url) => {
    console.log("getInfoFile", {file, url})
    const infoFile = {
        name:undefined,
        size:undefined,
        type:undefined,
        type2:undefined,
        width: undefined,
        height: undefined,
        aspectRatio: undefined,
        framesLength: undefined,
        averageColor: undefined,
        enclosure: undefined
    }

    infoFile.name = file.name
    infoFile.size = file.size
    infoFile.type = file.type

    infoFile.type2 = ['image','video'].includes(file.type.split('/')[0]) ? 
            file.type.split('/')[0]
        : ['pdf'].includes(file.type.split('/')[1]) ?
            file.type.split('/')[1]
        : undefined;
    
    // get dimensions & averageColor
    if (infoFile.type && url) { 
        

        if (infoFile.type.startsWith('image/')) {
            let img = new Image();
            infoFile.enclosure = url
            await new Promise((resolve) => {
                img.onload = async (e) => {
                    infoFile.width= img.width,
                    infoFile.height= img.height,
                    infoFile.aspectRatio= img.width / img.height
         
                    let facColor = await fac.getColorAsync(e.target);
                    if (facColor.hex) infoFile.averageColor = facColor.hex
                    resolve();
                };
                img.onerror = () => {
                    resolve();
                };
                img.src = url;
            });
        }

        if (infoFile.type == 'image/gif') {
            infoFile.enclosure = url
            let buffer = await fileToArrayBuffer(file);
            let gif = parseGIF(buffer);
            let frames = decompressFrames(gif, false);
            infoFile.framesLength= frames.length
        }

        if (infoFile.type.startsWith('video/')) {
            let video = document.createElement('video');
            video.preload = 'auto';
            video.src = url;
            video.muted = true;
            video.crossOrigin = 'anonymous'; 

            await new Promise((resolve) => {
                video.onloadedmetadata = async (e) => {
                    infoFile.width = video.videoWidth;
                    infoFile.height = video.videoHeight;
                    infoFile.aspectRatio = video.videoWidth / video.videoHeight;
                    infoFile.duration = video.duration;
                    video.currentTime = 0;
                };

                video.onseeked = async () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0);

                    const frameDataUrl = canvas.toDataURL();
                    let facColor = await fac.getColorAsync(frameDataUrl);
                    if (facColor.hex) {
                        infoFile.averageColor = facColor.hex;
                    }

                    infoFile.enclosure = await canvasToBlobURL(canvas, 0.8);

                    if (infoFile.enclosure) {
                        const fetchBlob = await fetch(infoFile.enclosure);
                        const blob = await fetchBlob.blob();
                        file = new File([blob], `uploaded-file.${blob.type}`, { type: blob.type });

                         // use s3
                        let uploadUrl = null
                        uploadUrl = await fetch(`${process.env.VUE_APP_API_HOST}/tools/get-upload-url?fileName=${encodeURIComponent(`thumbnail-uploaded-file`)}&fileType=${encodeURIComponent(blob.type)}`)

                        if(uploadUrl && uploadUrl.body && uploadUrl.body.uploadURL && uploadUrl.body.urlFinal) {
                            await axios.put(uploadUrl.body.uploadURL, file, {
                                headers: {
                                    'Content-Type': info.type
                                },
                                onUploadProgress: async (progressEvent) => {
                                    let percentProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                    if(percentProgress == 100)
                                        infoFile.enclosure = uploadUrl.body.urlFinal
                                }
                            });

                        }
                        else 
                            uploadUrl = null

                        if(!uploadUrl) {

                            const formData = new FormData();
                            formData.append('file', file);

                            const userId = JSON.parse(localStorage.user).id;
                            const response = await fetch(`${process.env.VUE_APP_VIDEO_API_HOST}/image/upload?u=${userId}`, {
                                method: 'POST',
                                body: formData
                            });
                            
                            const {file_url} = await response.json();
                            infoFile.enclosure = file_url
                        }
                    }
                   
                    resolve();
                };
        
                video.onerror = () => resolve();
                // video.src = url;
            });
            // video.src = '';
        }

        if (infoFile.type === 'application/pdf') {
            try {
                let doc = await getDocument(url).promise;
                let page = await doc.getPage(1);
                const canvas =  await makeThumb(page)
                infoFile.enclosure = await canvasToBlobURL(canvas, 0.8);
    
                if (infoFile.enclosure) {
                    const fetchBlob = await fetch(infoFile.enclosure);
                    const blob = await fetchBlob.blob();
                    file = new File([blob], `uploaded-file.${blob.type}`, { type: blob.type });
    
                    // use s3
                    let uploadUrl = null
                    uploadUrl = await fetch(`${process.env.VUE_APP_API_HOST}/tools/get-upload-url?fileName=${encodeURIComponent(`thumbnail-uploaded-file`)}&fileType=${encodeURIComponent(blob.type)}`)
                    if(uploadUrl && uploadUrl.body && uploadUrl.body.uploadURL && uploadUrl.body.urlFinal) {
                        await axios.put(uploadUrl.body.uploadURL, file, {
                            headers: {
                                'Content-Type': info.type
                            },
                            onUploadProgress: async (progressEvent) => {
                                let percentProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                if(percentProgress == 100)
                                    infoFile.enclosure = uploadUrl.body.urlFinal
                            }
                        });

                    }
                    else 
                        uploadUrl = null

                    if(!uploadUrl) {

                        const formData = new FormData();
                        formData.append('file', file);
        
                        const userId = JSON.parse(localStorage.user).id;
                        const response = await fetch(`${process.env.VUE_APP_VIDEO_API_HOST}/image/upload?u=${userId}`, {
                            method: 'POST',
                            body: formData
                        });

                        
                        const {file_url} = await response.json();
                        infoFile.enclosure = file_url
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

  
    
    return infoFile
}

export const getErrorNetworkFile = (file) => {
   
    const maxSizePerNetwork = {
        image: {facebook:4,twitter:5,instagram:8, google: 5, tiktok: 20},
        video: {facebook:1024,twitter:512, linkedin:5000, instagram:1024, tiktok: 4000}
    }
    const maxDimensionPerNetwork = {
        image: {twitter:'8192x8192', google: '2120x1192', linkedin: 36152320, tiktok: '1080x1080', instagram: '1.91:1'},
        video: {twitter:'8192x8192', linkedin: 36152320, tiktok: '4096x4096'}
    }
    const minDimensionPerNetwork =  {
        image: {twitter:'4x4', google: '250x250', instagram: '9:16'},
        video: {twitter:'4x4', tiktok: '360x360'}
    }
    const maxFrameGif= {twitter: 350,linkedin: 250}

    const errorNetwork = {}

    const addErrorFile = (network, property, textError) => {
        errorNetwork[network] = {
            ...(errorNetwork[network] || {}),
            [property] : textError
        }
    }

    for (const network of listNetworkSort) {
        console.log("getErrorNetworkFile", {network, file})
        const infoFile =  {...file.info, ...(file.normalizedNetworks && file.normalizedNetworks[network] && file.normalizedNetworks[network].info ? file.normalizedNetworks[network].info : {})}
        console.log("getErrorNetworkFile", {network, infoFile})

        //size
        if (maxSizePerNetwork[infoFile.type2] && maxSizePerNetwork[infoFile.type2][network]) {
            const sizeInMo = infoFile.size / (1024 * 1024)
            const maxSize = maxSizePerNetwork[infoFile.type2][network]
            if (sizeInMo >= maxSize )
            {
                addErrorFile(network, 'size', `La taille maximum est de ${maxSize}Mo`)
            }
       
        }  

        //Dimension max
        if (maxDimensionPerNetwork[infoFile.type2] && maxDimensionPerNetwork[infoFile.type2][network]) {
            const dimension = maxDimensionPerNetwork[infoFile.type2][network]
            if (Number.isInteger(dimension)) {
                if (infoFile.width * infoFile.height > dimension) {
                    addErrorFile(network,'size', `Le media est trop grand et dépasse les dimensions autorisées.`)
                }
            }else if(dimension.includes('x')){
                const [maxWidth,maxHeight] = dimension.split('x')
                if (infoFile.width > maxWidth || infoFile.height > maxHeight) {
                    addErrorFile(network,'size', `Les dimensions du media ne doivent pas dépasser ${maxWidth} pixels de largeur et ${maxHeight} pixels de hauteur.`)
                }
            }else if (dimension.includes(':')) {
                const [ratioWidth,ratioHeight] = dimension.split(':')
                if (infoFile.aspectRatio > parseFloat(ratioWidth) / parseFloat(ratioHeight)){
                    addErrorFile(network,'size', `Le ratio du media doit être inférieur à ${dimension}.`)
                }
            }
        }

           //Dimension min
        if (minDimensionPerNetwork[infoFile.type2] && minDimensionPerNetwork[infoFile.type2][network]) {
            const dimension = minDimensionPerNetwork[infoFile.type2][network]
            if(Number.isInteger(dimension)){
                if (infoFile.width * infoFile.height < dimension) {
                    addErrorFile(network,'size', `Le media est trop petit et n'atteint pas les dimensions autorisées.`)
                }
            }else if (dimension.includes('x')) {
                const [minWidth,minHeight] = dimension.split('x')
                if (infoFile.width < minWidth || infoFile.height < minHeight) {
                    addErrorFile(network,'size', `Les dimensions du media doivent dépasser ${minWidth} pixels de largeur et ${minHeight} pixels de hauteur.`)
                }
            }else if (dimension.includes(':')) {
                const [ratioWidth,ratioHeight] = dimension.split(':')
                if (infoFile.aspectRatio < parseFloat(ratioWidth) / parseFloat(ratioHeight)){
                    addErrorFile(network,'size', `Le ratio du media doit être supérieur à ${dimension}.`)
                }
            }
        }

        //max frame gif
        if (maxFrameGif[network] && infoFile.framesLength && Number.isInteger(infoFile.framesLength)) {
            if (infoFile.framesLength > maxFrameGif[network]) {
                addErrorFile(network,'frame', `Le GIF dépasse le nombre maximum de frames autorisées.`)
            }
        }

    }
    console.log("errorNetwork result", errorNetwork)
    return errorNetwork
}

export const findDifferences = (defaultObj, modifiedObj) => {
    let differences = {};

    // try {
    //     if (Object.keys(defaultObj).length !== Object.keys(modifiedObj).length) return modifiedObj
    //     if (Object.keys(defaultObj).join('') !== Object.keys(modifiedObj).join('')) return modifiedObj
    // } catch (error) {
    //     return modifiedObj
    // }

    if (typeof modifiedObj !== 'object' && modifiedObj !== null) return modifiedObj
    
    const allKeys = [...(new Set(Object.keys(defaultObj).concat(Object.keys(modifiedObj))))] 
    
    // Parcourir les propriétés de l'objet par défaut
    for (let key of allKeys) {
        if (!modifiedObj.hasOwnProperty(key)) {
            differences[key] = 'deleted_value'   
        }else if (!defaultObj.hasOwnProperty(key)) {
            differences[key] = modifiedObj[key]
        }else{
            if (typeof defaultObj[key] === 'object' && defaultObj[key] !== null) {
                if (Array.isArray(defaultObj[key])) {
                    // Comparer les tableaux
                    if (JSON.stringify(defaultObj[key]) !== JSON.stringify(modifiedObj[key])) {
                        differences[key] = modifiedObj[key];
                    }
                } else if (defaultObj[key] instanceof Set) {
                    // Comparer les Set
                    if (JSON.stringify([...defaultObj[key]]) !== JSON.stringify([...modifiedObj[key]])) {
                        differences[key] = modifiedObj[key];
                    }
                } else {
                    // Comparer les objets (récursion)
                    const objDiff = findDifferences(defaultObj[key], modifiedObj[key]);

                    if (typeof objDiff !== 'object' || Object.keys(objDiff).length > 0) {
                        differences[key] = objDiff;
                    }
                }
            } else {
                // Comparer les valeurs primitives
                if (defaultObj[key] !== modifiedObj[key]) {
                    differences[key] = modifiedObj[key];
                }
            }
        }
    }
    return differences;
}

export const mergeUpdates = (defaultObj, updateObj) => {
    for (let key in updateObj) {
        if (updateObj.hasOwnProperty(key)) {
            // Si la valeur est un objet, on doit faire une fusion récursive
            if (updateObj[key] === 'deleted_value'){
                delete defaultObj[key]
            }else if (typeof updateObj[key] === 'object' && updateObj[key] !== null && !Array.isArray(updateObj[key])) {
                // Si l'objet par défaut n'a pas cette clé, on initialise un objet vide
                if (!defaultObj[key]) {
                    defaultObj[key] = {};
                }
                // Fusion récursive
                mergeUpdates(defaultObj[key], updateObj[key]);
            } else {
                // Sinon, on remplace directement la valeur
                defaultObj[key] = updateObj[key];
            }
        }
    }
    return defaultObj;
}

export const deepClone = (obj) => {
    // Vérifier si c'est un objet ou un tableau
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    // Gérer les dates
    if (obj instanceof Date) {
        return new Date(obj);
    }

    // Gérer les tableaux
    if (Array.isArray(obj)) {
        return obj.map(item => deepClone(item));
    }

    // Gérer les objets Set
    if (obj instanceof Set) {
        return new Set([...obj].map(item => deepClone(item)));
    }

    // Gérer les objets Map
    if (obj instanceof Map) {
        return new Map(Array.from(obj.entries()).map(([key, value]) => [deepClone(key), deepClone(value)]));
    }

    // Gérer les autres objets (Object)
    const copy = {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            copy[key] = deepClone(obj[key]);
        }
    }
    
    return copy;
}

export const unescapeSpecialChars = (str) => {
    // Remplacer les séquences échappées par leurs équivalents littéraux
    return str
        .replace(/\\n/g, '\n')          // Newline '\n'
        .replace(/\\t/g, '\t')          // Tab '\t'
        .replace(/\\r/g, '\r')          // Carriage return '\r'
        .replace(/\\f/g, '\f')          // Form feed '\f'
        .replace(/\\v/g, '\v')          // Vertical tab '\v'
        .replace(/&nbsp;/g, ' ')        // '&nbsp;' -> space ' '
        .replace(/\\\\/g, '\\');        // Backslash '\\'
}

export const getVideoDuration = (url) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = url;

        video.addEventListener('loadedmetadata', function() {
            resolve(video.duration);  // Renvoie la durée en secondes
        });

        video.addEventListener('error', function() {
            reject('Impossible de charger la vidéo/musique.');
        });
    });
}

const makeThumb = async (page) => {
    // draw page to fit into 96x96 canvas
    var vp = page.getViewport({ scale: 1, });
    var canvas = document.createElement("canvas");
    var scalesize = 1;
    canvas.width = vp.width * scalesize;
    canvas.height = vp.height * scalesize;
    var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);

    return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
        return canvas; 
    });
}

const fileToArrayBuffer = async (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function(e) {
            let arrayBuffer = new Uint8Array(reader.result);
            resolve(arrayBuffer)
        }

        reader.readAsArrayBuffer(file);
    });
}

export const customModeIsAvailable = ({
    draftInstance
}) => {

    //retourne les networks concernés ou false
    //reserver au mode standard

    const countPagePerNetwork = draftInstance.pages.countPagePerNetwork
    const networksSelected = draftInstance.pages.networksSelected
    const idPagesSelected = draftInstance.pages.ids

    //verifier si une personnalisation est deja active
    if (
        networksSelected.some((network) => Object.keys(draftInstance.form.merge.saveAllFormData.networks).includes(network)) ||
        idPagesSelected.some((id) => Object.keys(draftInstance.form.merge.saveAllFormData.pages).includes(id))
    ) {
        return true
    }
    

    const networksValid = networksSelected.filter((network) => draftInstance?.form?.networks?.[network]?.validator?.isValid)
    
    if (
        networksValid.length > 1 ||
        networksValid.some((network) => countPagePerNetwork[network] > 1)
    ) {
        return true
    }

    return false
}


export const postNetworkValidator = (networks, filesByNetwork, formDataNetwork, text) => {
    const validator = {}

    networks.forEach(networkName => {
        validator[networkName] = {
            isValid : true,
            showRender : true,
            error : []
        }

        switch (networkName) {
            case 'facebook':
            
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'instagram':
                if (!filesByNetwork[networkName].length) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image ou une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'linkedin':
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link &&
                    !formDataNetwork[networkName].survey.active
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu, un lien ou un sondage."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'threads':
                
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'twitter':
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'bluesky':
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un text, une image ou une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'tiktok':
                if (
                    !filesByNetwork[networkName].length
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image ou une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'google':
                if (
                    !filesByNetwork[networkName].length &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'telegram':
                if (
                    text.length == 0
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter un contenu."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'pinterest':
                if (
                    !filesByNetwork[networkName].length &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image, une vidéo ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'youtube':
                if (
                    !filesByNetwork[networkName].length
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            default:
                break;
        }
    });
    
    return validator
}

export const foreachSaveAllFormData = async (saveAllFormData, cb) => {
    if (saveAllFormData.main) await cb(saveAllFormData.main, 'main')
    if (saveAllFormData.networks) {
        for (const [networkName, value] of Object.entries(saveAllFormData.networks)) {
            await cb(saveAllFormData.networks[networkName], 'network')
        }          
    }

    if (saveAllFormData.pages) {
        for (const [pageId, value] of Object.entries(saveAllFormData.pages)) {
            await cb(saveAllFormData.pages[pageId], 'page')
        }  
    }
}

function canvasToBlobURL(canvas, quality) {
    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            const blobUrl = URL.createObjectURL(blob);
            resolve(blobUrl);
        }, 'image/jpeg', quality);
    });
}
